<template>
  <div v-if="languages.length" class="spoken-langs">
    <p class="spoken-langs__title">
      <vb-icon class="spoken-langs__icon" :name="'chat'" :color="sass('primary')" :size="16" />
      <span>Lingue parlate:</span>
    </p>
    <span
      class="spoken-langs__text"
      v-for="(lang, lang_index) in languages"
      :key="_uid + 'lang' + lang_index"
    >
      {{ get_languages(lang).label }}
    </span>
  </div>
</template>

<script>
import { get_languages } from "@liveeps/resources";

export default {
  name: 'spoken-langs',

  components: {
  },

  props: {
    languages: Array
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_languages = get_languages
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .spoken-langs {
    font-size: $font-size-md;

    @include media-breakpoint-up(md){
      display: flex;
      align-items: center;
    }

    &__icon {
      margin-right: 5px;
      transform: scaleX(-1);
    }

    &__title {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width/5;

      @include media-breakpoint-up(md){
        margin-bottom: 0;
      }
    }

    &__text {
      margin-right: $grid-gutter-width/5;
      font-weight: $vb-font-weight-semibold;
      display: flex;
      align-items: center;

      &:after {
        content: '';
        width: 4px;
        height: 4px;
        display: inline-block;
        border-radius: $border-radius;
        background-color: $gray-600;
        margin-left: $grid-gutter-width/5;
      }

      &:last-child {
        margin-right: 0;

        &:after {
          display: none;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

</style>